import cn from 'classnames'
import { useState } from 'react'

import {
  Box,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  FormLabel,
  IconButton,
  Typography,
  useMediaQuery
} from '@mui/material'

import InfoIcon from '../../assets/icons/InfoIcon'
import CustomTooltip from '../Tooltip'
import TooltipModal from '../TooltipModal'
import { StyledCheckboxGroup } from './styled'

const CheckboxGroup = ({
  label,
  tooltip,
  className,
  value = [],
  groupName,
  options = [],
  onChange,
  helperText,
  renderItemFooter,
  ...props
}) => {
  const selectedIds = Array.isArray(value) ? value : []
  const isSmallScreen = useMediaQuery('(max-width: 1024px)')
  const [isOpenTooltipModal, setIsOpenTooltipModal] = useState(false)

  const handleOpenTooltipModal = () => setIsOpenTooltipModal(isOpenTooltipModal => !isOpenTooltipModal)

  return (
    <StyledCheckboxGroup {...props} className={className}>
      <FormControl>
        <FormLabel component='legend'>
          {tooltip ? (
            <Box className='checkbox-label-box'>
              <Typography className='checkbox-label'>{label}</Typography>
              <CustomTooltip title={tooltip}>
                <IconButton className='checkbox-content-tooltip'>
                  <InfoIcon />
                </IconButton>
              </CustomTooltip>
            </Box>
          ) : (
            <Typography className='checkbox-label'>{label}</Typography>
          )}
        </FormLabel>

        <FormGroup className='checkbox-group'>
          {options.map(item => {
            const id = item.id ?? item.value
            const checked = selectedIds.includes(id)

            return (
              <Box key={`checkbox-${id}`} className='checkbox-item'>
                <FormControlLabel
                  className={cn('checkbox-button', { checked })}
                  control={
                    <Checkbox
                      name={groupName}
                      value={id}
                      checked={checked}
                      onChange={(e, nextChecked) => onChange?.(id, nextChecked)}
                      sx={{
                        color: '#D5DADF',
                        '&.Mui-checked': { color: '#B8945C' },
                        '& .MuiSvgIcon-root': { fontSize: 28 }
                      }}
                    />
                  }
                  label={
                    <Box className='checkbox-button-box'>
                      <Box className='checkbox-button-content'>
                        <Typography className='checkbox-button-label checkbox-button-label-title'>
                          {item.nameTitle || item.name}
                          {!item.nameDescription && (
                            <span className='checkbox-tooltip-inline-wrap'>
                              {' '}
                              <CustomTooltip title={item.tooltip}>
                                <IconButton
                                  className='checkbox-content-tooltip checkbox-content-tooltip-inline'
                                  onClick={isSmallScreen ? handleOpenTooltipModal : null}
                                >
                                  <InfoIcon />
                                </IconButton>
                              </CustomTooltip>
                            </span>
                          )}
                        </Typography>
                        {!!item.nameDescription && (
                          <Typography className='checkbox-button-label checkbox-button-label-description'>
                            {item.nameDescription}
                            <span className='checkbox-tooltip-inline-wrap'>
                              {' '}
                              <CustomTooltip title={item.tooltip}>
                                <IconButton
                                  className='checkbox-content-tooltip checkbox-content-tooltip-inline'
                                  onClick={isSmallScreen ? handleOpenTooltipModal : null}
                                >
                                  <InfoIcon />
                                </IconButton>
                              </CustomTooltip>
                            </span>
                          </Typography>
                        )}
                      </Box>
                      <Box className='checkbox-button-price'>
                        <Typography className='checkbox-button-label checkbox-button-price-text'>
                          £{item.price}
                        </Typography>
                      </Box>
                      <TooltipModal title='View details' open={isOpenTooltipModal} onClose={handleOpenTooltipModal}>
                        {item.tooltip}
                      </TooltipModal>
                    </Box>
                  }
                />
                {renderItemFooter && <Box className='checkbox-button-footer'>{renderItemFooter(item, checked)}</Box>}
              </Box>
            )
          })}
        </FormGroup>

        {!!helperText && <FormHelperText className='checkbox-helper-text'>{helperText}</FormHelperText>}
      </FormControl>
    </StyledCheckboxGroup>
  )
}

export default CheckboxGroup
